import React from 'react'
import Sidebar from '../components/sidebar'
import Header from '../components/Header'
import EditSliderMain from '../components/sliders/EditSliderMain'

const SliderEditScreen = ({match}) => {
    const sliderId = match.params.id;
    return (
        <>
            <Sidebar />
            <main className="main-wrap">
                <Header />
                <EditSliderMain sliderId={sliderId} />
            </main>
        </>
    )
}

export default SliderEditScreen